<script context="module">
  let cssLoaded = false
</script>

<script>
  import { onMount } from 'svelte'
  import { calcPxNum, stringifyStyle } from './utils'
  export let name = ''
  export let size = '1rem'
  export let color = undefined
  export let bold = false
  export let cursor = 'normal'


  $: style = {
    'font-size': calcPxNum(size),
    'color': color,
    'font-weight': bold ? 'bold' : 'normal',
    'cursor': cursor,
  }
  
  onMount(() => {
    if (!cssLoaded) {
      cssLoaded = true
      let link = document.createElement('link')
      link.type = 'text/css'
      link.rel = 'stylesheet'
      link.href = '/iconfont/iconfont.css'
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  })

</script>


<i 
  class={'iconfont icon-' + name}
  style={stringifyStyle(style)}
  on:click
  on:keypress
></i>